import React from "react";

/* Three small text inputs for "today, in three words" check-ins.
   Optional — empty stays empty, no validation. */
export default function ThreeWords({ value, onChange, testIdPrefix }) {
  const update = (i, v) => {
    const next = [...value];
    next[i] = v;
    onChange(next);
  };
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 }} data-testid={testIdPrefix}>
      {[0, 1, 2].map((i) => (
        <input
          key={i}
          data-testid={`${testIdPrefix}-${i}`}
          type="text"
          maxLength={20}
          value={value[i]}
          onChange={(e) => update(i, e.target.value)}
          placeholder={`word ${i + 1}`}
          style={{
            width: "100%",
            border: "1px solid rgba(143, 196, 224, 0.32)",
            borderRadius: 0,
            padding: "10px 8px",
            fontFamily: "'IM Fell DW Pica', serif",
            fontStyle: "italic",
            fontSize: 16,
            color: "var(--cream)",
            background: "rgba(255, 255, 255, 0.025)",
            outline: "none",
            textAlign: "center",
            transition: "border-color 0.3s ease",
          }}
          onFocus={(e) => (e.target.style.borderColor = "var(--terracotta-soft)")}
          onBlur={(e) => (e.target.style.borderColor = "rgba(143, 196, 224, 0.32)")}
        />
      ))}
    </div>
  );
}
